import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M22.52,28.51l-5.95-4.73H6.8a3,3,0,0,1-3-3V7.05a3,3,0,0,1,3-3H25.2a3,3,0,0,1,3,3V20.81a3,3,0,0,1-3,3H23ZM6.8,5.39A1.67,1.67,0,0,0,5.14,7.05V20.81A1.67,1.67,0,0,0,6.8,22.48H17L21.47,26l.37-3.53H25.2a1.67,1.67,0,0,0,1.66-1.67V7.05A1.67,1.67,0,0,0,25.2,5.39Z' }),
  React.createElement('rect', { x: '9.31', y: '8.68', width: '13.38', height: '1.3' }),
  React.createElement('rect', { x: '9.31', y: '12.89', width: '13.38', height: '1.3' }),
  React.createElement('rect', { x: '9.31', y: '17.1', width: '13.38', height: '1.3' })
));